import * as React from "react";
import {FC, useEffect, useLayoutEffect, useRef, useState} from "react";
import {Route, Routes, useLocation} from "react-router-dom";
import {PublicPage} from "./public/PublicPage";
import {PrivatePage} from "./restricted/PrivatePage";
import {StyledDiv} from "../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {LoginPage} from "./public/LoginPage";
import {useRecoilValue} from "recoil";
import {AccessContextData} from "../providers/access/AppContextProvider";
import {PosStart} from "./restricted/PosStart";
import {LoginRedirect} from "./LoginRedirect";
import {Analytics, AnalyticsEvent} from "../analytics/Analytics";
import axios from "axios";

export const PageRouter: FC<any> = () => {
   const ref = useRef<any>();
   const [top, setTop] = useState<number>(0);
   const appContext = useRecoilValue(AccessContextData);
   let location = useLocation();
   useEffect(() => {
      try {
         const footer = document.getElementById('shopify-section-footer')
         if (footer) {
            if (location.pathname !== '/') {
               footer.style.display = 'none'
            }
         }
      } catch (e) {
         console.log('Unable to update footer visibility', e)
      }
   }, [location])

   useLayoutEffect(() => {
      setTop(ref.current.offsetTop);

      const timeout = setTimeout(() => {
         if (window.appScrollIntoView) {
            window.scrollTo({
               top: ref.current.offsetTop + (window.appScrollOffsetY || 0),
               left: 0,
               behavior: 'smooth'
            });
         }
      }, 300)
      return () => clearTimeout(timeout)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      Analytics.event(AnalyticsEvent.trackAppStart);

      axios({
         method: 'get',
         url: 'https://create2stay-frontdoor.azurewebsites.net/api/track?tf=' + appContext.shopId
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      Analytics.event(AnalyticsEvent.trackStepChange, {
         pathname: location.pathname
      });
      const timeout = setTimeout(() => {
         window.scrollTo({
            top: (window.appDetectScrollTop ? top : 0) + (window.appScrollOffsetY || 0),
            left: 0,
            behavior: 'smooth'
         });
      }, 100)
      return () => clearTimeout(timeout)
      // eslint-disable-next-line
   }, [location])

   const classes = useStyles();
   return <StyledDiv type={"main"} className={classes.page} ref={ref}>
      {appContext?.pos && <div className={classes.pos}>Point of Sale Mode</div>}
      {window.loginMode && <Routes>
         <Route path={"/"} element={<LoginPage/>}/>
      </Routes>}
      {!window.loginMode && <Routes>
         <Route path={"/"} element={<PublicPage/>}/>
         <Route path={"login"} element={<LoginPage/>}/>
         <Route path={"pos"} element={<PosStart/>}/>
         <Route path={"main/*"} element={<PrivatePage/>}/>
         <Route path={":accessToken/*"} element={<LoginRedirect/>}/>
      </Routes>}
   </StyledDiv>
}

const useStyles = makeStyles({
   page: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
   },
   pos: {
      backgroundColor: 'red',
      textAlign: 'center',
      color: 'white',
      fontSize: '30px'
   }
});